import React from 'react';
import './Research.css';
import fireblightPoster from '../assets/researchPosters/FireblightPoster.jpg';
import asdrpPoster from '../assets/researchPosters/ASDRPPoster.jpg';
import quantitativeDef from '../assets/researchPosters/QuantitativeDef.jpg';
import EurIPS from '../assets/researchPosters/EurIPS.jpg';
// import NvidiaPoster2024 from '../assets/researchPosters/NvidiaPoster2024.jpg';
// import NvidiaPoster2025 from '../assets/researchPosters/NvidiaPoster2025.jpg';
import comediffPoster from '../assets/researchPosters/CoMEDiff.jpg';

function Research() {
  return (
    <div className="research-container">
      <h2>Research</h2>
      <div className="poster-gallery">
        <img src={fireblightPoster} alt="Fireblight Poster" className="research-poster" />
        <img src={asdrpPoster} alt="ASDRP Poster" className="research-poster" />
        <img src={quantitativeDef} alt="Quantitative Defense Poster" className="research-poster" />
        <img src={EurIPS} alt="EurIPS Poster" className="research-poster" />
        {/* <img src={NvidiaPoster2024} alt="Nvidia 2024 Poster" className="research-poster blurred-poster" />
        <img src={NvidiaPoster2025} alt="Nvidia 2025 Poster" className="research-poster blurred-poster" /> */}
        <img src={comediffPoster} alt="CoMEDiff Poster" className="research-poster blurred-poster" />
      </div>
    </div>
  );
}

export default Research;
